export interface SalesPackDespatchItemReport {
  orderNo: string;
  stockNo: string;
  productKey: string;
  productDescription: string;
  grossQuantity: number;
  nettQuantity: number;
  noOfItems: number;
  unitOfMeasure: string;
}
